export default {
    isBasketEmpty: function (state) {
        return state.basket.itemPacks.length === 0;
    },
    basket: function (state) {
        return state.basket;
    },
    isLoadingBasket: function (state) {
        return state.loadingContent;
    },
    isLoadingCredits: function (state) {
        return state.loadingCredits;
    },
    isDeliveryAndPaymentSelected: function (state) {
        return state.deliveryAndPaymentSelected;
    },
    freeTransportLimit: function (state) {
        return state.freeTransportLimit;
    },
    user: function (state) {
        return state.user;
    },
};
